<template>
  <div class="menu__dropdown">
    <div class="menu__link">
      <label>
        <input
          type="checkbox"
          value="filter-value"
          v-model="listItem.checked"
          @change="
            $parent?.$emit(
              'filter-update',
              handleCheckboxInputChange($event),
              listItem.label,
              listItem.type,
              'parent'
            )
          "
        />
        <!-- using $parent to emit to grandparent component copackerfacilites(which contains filter-container which contains child-list-->
        <span>{{ listItem.label }}</span>
      </label>
      <span
        class="menu__icon"
        :class="{ menu__iconclose: showDropdown }"
        @click="showDropdown = !showDropdown"
      ></span>
    </div>
    <ul class="menu__dropdown-menu" :class="{ showDropdown: showDropdown }">
      <!--      TBD The key was id which ddesn't exist-->
      <li v-for="childItem of listItem.children" :key="childItem.label">
        <label>
          <input
            id="filterCheckbox"
            type="checkbox"
            class="ClearAllSelections"
            value="filter-value"
            v-model="childItem.checked"
            @change="
              $parent?.$emit(
                'filter-update',
                handleCheckboxInputChange($event),
                listItem.label + '-' + childItem.label,
                listItem.type,
                'child'
              )
            "
          />
          <span>{{ childItem.label }} </span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import type { FilterListItem } from "@/shared/ui/filter-container/filterListItem";

defineProps<{
  listItem: FilterListItem;
}>();

const showDropdown = ref(false);

function handleCheckboxInputChange(event: Event): boolean {
  return (event.target as HTMLInputElement).checked;
}
</script>

<style scoped lang="scss">
label {
  font-size: 13px;
  margin-bottom: 0;
  span {
    top: -2px;
    margin-left: 2px;
    position: relative;
  }
}
ul {
  margin: 0;
  list-style: none;
}
.menu__dropdown-menu {
  font-size: 13px;
  border-left: 1px solid #efefef;
  margin: 0px 0px 0px 5px;
  padding-left: 10px;
  padding-bottom: 0px;
  padding-top: 0.5rem;
  display: none;
  &.showDropdown {
    display: flex;
    flex-flow: column;
    margin-bottom: 10px;
    transition: all 0.3s ease-in-out;
  }
}
.menu__dropdown {
  display: flex;
  flex-flow: column;
  position: relative;
}
.menu__link {
  display: flex;
  align-items: center;
  padding-right: 1rem;
}
.menu__icon {
  display: block;
  cursor: pointer;
  width: 10px;
  height: 10px;
  margin-left: 7px;
  top: -1px;
  position: relative;
  background-image: url("https://res.cloudinary.com/orthodox-union/image/upload/co_rgb:222,e_colorize:100,f_png/v1618762616/iconmonstr-plus-2_hvrcfp.svg");
  background-size: contain;
  &:hover {
    opacity: 0.7;
  }
  &.menu__iconclose {
    background-image: url("https://res.cloudinary.com/orthodox-union/image/upload/co_rgb:222,e_colorize:100,f_png/v1618762616/iconmonstr-minus-2_irbmrp.svg");
  }
}
</style>
